import React from 'react';
import { CDBIcon } from 'cdbreact';
import { Pagination } from 'react-bootstrap';
import NavBarPeiix from '../../../NavBar';
import { useRecurringPayments } from './hooks/useRecurringPayments';
import { RecurringTable } from './components/RecurringTable';
import { RecurringFilters } from './components/RecurringFilters';
import { CreateRecurringModal } from './components/CreateRecurringModal';
import { CancelRecurringModal } from './components/CancelRecurringModal';
import LoadingOverlay from '../../../common/LoadingOverlay';

const RecurringPayments = () => {
    const {
        payments,
        loading,
        error,
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        showModal,
        setShowModal,
        handleCreatePayment,
        currentPage,
        totalPages,
        totalCount,
        handlePageChange,
        
        showCancelModal,
        setShowCancelModal,
        selectedPayment,
        cancelLoading,
        handleCancelClick,
        handleCancelConfirm
    } = useRecurringPayments();

    return (
        <div className="RecurringPayments flex-grow-1" style={{ backgroundColor: '#F8F9FA', minHeight: '100vh' }}>
            <NavBarPeiix />
            
            <div className="container-fluid p-4">
                {/* Header Section */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h3 className="fw-bold mb-0" style={{ color: '#3E3E3E', fontFamily: 'Montserrat, sans-serif' }}>
                            <CDBIcon icon="redo" className="me-2" /> Pagos Recurrentes
                        </h3>
                        <p className="text-muted small mb-0">Gestiona suscripciones y cobros automáticos</p>
                    </div>
                    
                    <button 
                        className="btn d-flex align-items-center gap-2 text-white px-4 py-2"
                        style={{ backgroundColor: '#0E9600', borderRadius: '8px', border: 'none' }}
                        onClick={() => setShowModal(true)}
                    >
                        <i className="bi bi-plus-lg"></i>
                        <span className="fw-bold">Nuevo Pago</span>
                    </button>
                </div>

                {/* Filters Section */}
                <RecurringFilters 
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    statusFilter={statusFilter}
                    setStatusFilter={setStatusFilter}
                />

                {/* Error Alert */}
                {error && (
                    <div className="alert alert-danger d-flex align-items-center" role="alert">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        {error}
                    </div>
                )}

                {/* Table Section */}
                <div className="bg-white rounded shadow-sm border overflow-hidden">
                    <RecurringTable items={payments} onCancel={handleCancelClick} />
                </div>

                {/* Paginación */}
                {totalPages > 1 && (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                        <Pagination>
                            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                            {[...Array(totalPages).keys()].slice(Math.max(0, currentPage - 3), Math.min(totalPages, currentPage + 2)).map(number => (
                                <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => handlePageChange(number + 1)}>
                                    {number + 1}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                        </Pagination>
                    </div>
                )}
            </div>

            {/* Modal for Creation */}
            <CreateRecurringModal 
                show={showModal} 
                onHide={() => setShowModal(false)}
                onSubmit={handleCreatePayment}
                loading={loading}
            />

            {/* Modal for Cancellation */}
            <CancelRecurringModal
                show={showCancelModal}
                onHide={() => setShowCancelModal(false)}
                onConfirm={handleCancelConfirm}
                payment={selectedPayment}
                loading={cancelLoading}
            />

            {/* Loading Overlay */}
            <LoadingOverlay show={loading} message="Procesando..." />
        </div>
    );
};

export default RecurringPayments;
